import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#000' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M0 0v2.75019527h3.9825L5.386875 7.2963599h16.8375l-1.940625 7.9881268H7.85625l.999375 3.2338697h9.523125l-.00375.0149977c.058125-.0037495.11625-.0093736.174375-.0093736 1.569375 0 2.8425 1.2729261 2.8425 2.8420559 0 1.190439-.733125 2.2084049-1.77 2.6320887H24V0H0zm9.2475 23.9962504h8.233125c-1.03875-.4236838-1.77-1.4416497-1.77-2.6320887 0-.3055772.050625-.5999062.13875-.8773629H10.87875c.09.275582.13875.569911.13875.8773629 0 1.190439-.733125 2.2084049-1.77 2.6320887zm-3.915-2.6320887c0-.7330104.279375-1.4004062.736875-1.9028277L1.90125 5.4666458H0v18.5296046h7.1025c-1.036875-.4236838-1.77-1.4416497-1.77-2.6320887z"
          fill="#000"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
